export default "__VITE_ASSET__BcQ4XhmC__"